import React, { useEffect, useState } from "react";
import {
  DeleteCountryStatistics,
  GetCountryStatisticsAll,
  UpdateCountryStatistics,
} from "../../../../../../../../core/Services";
import { BsFillTrashFill } from "react-icons/bs";
import { BsFillPencilFill } from "react-icons/bs";
import { Dialog } from "primereact/dialog";
import { Button } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import CountryFlag from "react-country-flag";
import { Paginator } from "primereact/paginator";

export default function CountryVisitTable({ uniqueCustomerId, countriees, tableKey, months }) {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [editMode, setEditMode] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const toast = useToast();

  useEffect(() => {
    GetCountryStatisticsAll(uniqueCustomerId)
      .then((data) => {
        setCountries(data.data);
      })
      .catch((error) => {
        console.log("Ülke Veri Çekme Hatası", error);
      });
  }, [uniqueCustomerId, tableKey , deleteSuccess]);

  useEffect(() => {
    if (deleteSuccess) {
      toast({
        title: "Başarılı",
        description: "Veri başarıyla silindi.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      setDeleteSuccess(false);
    }
  }, [deleteSuccess, toast]);

  const handleDelete = (countryId) => {
    setSelectedCountry(countryId);
    setDisplayConfirmation(true);
  };

  const onDeleteConfirmation = () => {
    DeleteCountryStatistics(selectedCountry);
    setDeleteSuccess(true);
    setSelectedCountry("");
    setDisplayConfirmation(false);
  };

  const onHide = () => {
    setDisplayConfirmation(false);
  };

  const handleEdit = (countryId) => {
    setEditMode(countryId);
  };

  const handleSave = (editedCountry) => {
    UpdateCountryStatistics(editedCountry);
    setEditMode(null);
  };

  const handleInputChange = (event, countryId) => {
    const { name, value } = event.target;
    const updatedCountries = countries?.map((country) =>
      country.id === countryId ? { ...country, [name]: value } : country
    );
    setCountries(updatedCountries);
  };
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  return (
    <div>
      <div className="mb-3 font-bold text-xl">Tablo Görünümü :</div>
      <table
        style={{
          fontFamily: "arial, sans-serif",
          borderCollapse: "collapse",
          width: "80%",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            ></th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Dönem
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Ülkeler
            </th>
          
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Ziyaretçi Sayısı
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              İşlemler
            </th>
          </tr>
        </thead>
        <tbody>
          {countries &&
            countries?.slice(first, first + rows)?.map((country, index) => (
              <tr
                key={country.id}
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === country.id ? (
                    <input
                      type="text"
                      name="country"
                      value={country.country}
                      onChange={(e) => handleInputChange(e, country.id)}
                    />
                  ) : (
                    index + 1
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {months?.find((months) => months.value === country.month)
                    ?.name || ""}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === country.id ? (
                    <input
                      type="text"
                      name="country"
                      value={country.country}
                      onChange={(e) => handleInputChange(e, country.id)}
                    />
                  ) : (
                    <div>
                      <CountryFlag
                        countryCode={country.country}
                        svg
                        style={{ marginRight: "8px" }}
                      />
                      {
                        countriees?.find(
                          (dataType) => dataType.code === country.country
                        )?.name
                      }
                    </div>
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === country.id ? (
                    <input
                      type="text"
                      name="visitor"
                      value={country.visitor}
                      onChange={(e) => handleInputChange(e, country.id)}
                    />
                  ) : (
                    country.visitor
                  )}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {editMode === country.id ? (
                    <button onClick={() => handleSave(country)}>Kaydet</button>
                  ) : (
                    <button onClick={() => handleEdit(country.id)}>
                      <BsFillPencilFill />
                    </button>
                  )}
                  <button
                    className="ml-2"
                    onClick={() => handleDelete(country.id)}
                  >
                    <BsFillTrashFill />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={countries?.length}
        onPageChange={onPageChange}
      />
      <Dialog
        visible={displayConfirmation}
        style={{ width: "450px" }}
        onHide={onHide}
        position="center"
        header="İçerik Düzenleme"
      >
        <p>Veriyi silmek istediğinize emin misiniz?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <Button colorScheme="red" onClick={onHide}>
            Hayır
          </Button>
          <Button colorScheme="green" onClick={onDeleteConfirmation}>
            Evet
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
